var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavReservation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 1.25019V2.49996C18.0013 2.49996 20.5001 4.73706 20.5001 7.49906L20.5 19.0009C20.5 21.7629 18.3458 24 15.8446 24H4.52703C2.02584 24 0.5 21.5163 0.5 18.7543L0.500113 7.25245C0.500113 4.49045 2.99893 2.5 5.50011 2.5V1.25023C5.50011 0.56285 5.87765 0 6.50011 0C7.12258 0 7.50011 0.56285 7.50011 1.25023V2.5L13.5001 2.49996V1.25019C13.5001 0.562814 13.8776 0 14.5001 0C15.1226 0 15.5001 0.562814 15.5001 1.25019Z",
    fill: "#B1B8C0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 5.5,
    y: 9,
    width: 4,
    height: 4,
    rx: 1,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 5.5,
    y: 14,
    width: 4,
    height: 4,
    rx: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 11.5,
    y: 9,
    width: 4,
    height: 4,
    rx: 1,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 11.5,
    y: 14,
    width: 4,
    height: 4,
    rx: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavReservation);
export default __webpack_public_path__ + "static/media/Nav_Reservation.9c4bea33b1158c760185b7b968785288.svg";
export { ForwardRef as ReactComponent };